/* DB-010 Sticky button functionality */
function activateSticky() {
    const changeTarget = document.querySelector('.quantity-submit-row__submit');
    if (changeTarget) {
        changeTarget.classList.add('sticky');
    }

    const placeholder = document.querySelector('.sticky-placeholder');
    if (placeholder) {
        placeholder.classList.add('active');
    }

    const chatButton = document.querySelector('#launcher');
    if (chatButton) {
        chatButton.classList.add('move-up');
    }
}

function removeSticky() {
    const changeTarget = document.querySelector('.quantity-submit-row__submit');
    if (changeTarget) {
        changeTarget.classList.remove('sticky');
    }
    
    const placeholder = document.querySelector('.sticky-placeholder');
    if (placeholder) {
        placeholder.classList.remove('active');
    }
    
    const chatButton = document.querySelector('#launcher');
    if (chatButton) {
        chatButton.classList.remove('move-up');
    }
}

function scrollDetection() {
    const detectTarget = document.querySelector('.quantity-submit-row');

    if (!detectTarget || !content) return;
    
    window.addEventListener("scroll", () => {
        const top = detectTarget.getBoundingClientRect().top;
        const content = document.querySelector('#content');
        
        // Only activate sticky if content is visible and button is at top of viewport
        if (top <= 0 && content.style.display !== 'none') {
            activateSticky();
        } else {
            removeSticky();
        }
    })
}

function resetChatButton() {
    const submitButtons = document.querySelectorAll('.quantity-submit-row__submit button');

    submitButtons.forEach(button => {
        button.addEventListener('click', () => {
            removeSticky();
        });
    });
}

function observeContentSection () {
    const content = document.querySelector('#content');
    const observer = new MutationObserver(() => {
        if (content.style.display === 'none') {
            removeSticky();
        }
    });
    observer.observe(content, { attributes: true, attributeFilter: ['style'] });
}

document.addEventListener("DOMContentLoaded", () => {
    scrollDetection();
    resetChatButton();
    observeContentSection();
})
